module.exports = "/_next/static/images/743deeef351c15be50d97e912decdaa3-terms-and-conditions.svg";